import { render, staticRenderFns } from "./DetailMedicalInfoNew.vue?vue&type=template&id=6bff1f16&scoped=true"
import script from "./DetailMedicalInfoNew.vue?vue&type=script&lang=js"
export * from "./DetailMedicalInfoNew.vue?vue&type=script&lang=js"
import style0 from "./DetailMedicalInfoNew.vue?vue&type=style&index=0&id=6bff1f16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff1f16",
  null
  
)

export default component.exports